import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
    selector: '[captureId]',
    standalone: false
})
export class CaptureIdDirective {
    constructor(private readonly el: ElementRef) {
    }

    @Input()
    set captureId(key: string) {
        this.el.nativeElement.setAttribute('capture-id', key);
    }

}
